const ColliderDB = [
    {
        colliderId:'receptionWallCollider',
        displayCollider:'N',
    }
];

export default ColliderDB;
